/**
 * @see https://sail.stripe.me/apis/navigation/createRoute
 */ function createRoute(route) {
    return route;
}
export default createRoute;

//# sourceMappingURL=createRoute.js.map